<template>
  <div>
    <div
      :class="{'opacity-50 cursor-not-allowed': (inProgress ||(session.startup_application && session.startup_application.status!='9' && !this.isStartupEcosystem))}"
    >
      <h1 class="text-bold text-blue mb-5">{{ this.newDeclarationReportingTitle }}</h1>
      <div
        v-if="isSubmitted && errors == null"
        class="alert alert-success bg-green-light border border-green text-sm text-green px-4 py-3 rounded relative mb-4"
      >
        <p class="mb-0">
          <strong class="font-bold">{{ $t("form.submitted") }}</strong>
        </p>
      </div>

      <div
        v-if="errors"
        class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 rounded relative mb-4"
        role="alert"
      >
        <p class="mb-0">
          <strong class="font-bold">{{ $t("form.correctErrors") }}</strong>
        </p>
      </div>
      <form autocomplete="off" name="formrequest" v-on:submit.prevent="requestFormSaveDraft()">
        <div v-for="(q, index) in requestForm.questions" :key="index+'question1'+index">
          <div v-if="q.category_id === null">
            <div v-if="$route.params.type_id == 4 || $route.params.type_id == 3">
              <q-form
                      :question="q"
                      :responses="responses"
                      :started="true"
                      @update-disabled="updateDisabled"
                      :showError="showError"
                      :requestForm="true"
                      @governorate="governoratechange"
                      :delegation="delegation"
                      :showTeam="showTeam"
              ></q-form>
            </div>
            <div v-else>
              <q-form
                      :question="q"
                      :responses="responses"
                      :started="true"
                      @update-disabled="updateDisabled"
                      :showError="showError"
                      :requestForm="true"
                      @governorate="governoratechange"
                      :delegation="delegation"
                      :showTeam="showTeam"
              ></q-form>
            </div>

          </div>
        </div>

        <div v-for="cat in requestForm.categories" :key="cat.sort_order">
      
          <h2
            class="text-red text-lg text-bold mb-5 pb-2 py-6 border-red-light border-b"
          >{{cat.name}}</h2>
          <div v-for="(q, index) in requestForm.questions" :key="index+'question2'+index">
           <div v-if="q.category_id === cat.id">
              <div>
                <div v-if="$route.params.type_id == 4 || $route.params.type_id == 3">
                  <q-form
                          :question="q"
                          :responses="responses"
                          :started="true"
                          @update-disabled="updateDisabled"
                          :showError="showError"
                          :requestForm="true"
                          @governorate="governoratechange"
                          :delegation="delegation"
                          :showTeam="showTeam"
                          :labelDate="session && session.startup_application && session.startup_application.label_created_at"
                  ></q-form>
                </div>
                <div v-else-if="$route.params.type_id == 14">
                  <q-form
                    :question="q"
                    :responses="responses"
                    :started="true"
                    @update-disabled="updateDisabled"
                    :showError="showError"
                    :requestForm="true"
                    @governorate="governoratechange"
                    :delegation="delegation"
                    :showTeam="showTeam"
                    :startLeaveDate="startLeaveDate"
                  ></q-form>
                </div>
                <div v-else-if="$route.params.type_id == 12">
                  <q-form
                    :question="q"
                    :responses="responses"
                    :started="true"
                    @update-disabled="updateDisabled"
                    :showError="showError"
                    :requestForm="true"
                    @governorate="governoratechange"
                    :delegation="delegation"
                    :showTeam="showTeam"
                    :startBourseDate="startBourseDate"
                    :endBourseDate="endBourseDate"
                  ></q-form>
                </div>
                <div v-else>
                  <q-form
                          :question="q"
                          :responses="responses"
                          :started="true"
                          @update-disabled="updateDisabled"
                          :showError="showError"
                          :requestForm="true"
                          @governorate="governoratechange"
                          :delegation="delegation"
                          :showTeam="showTeam"
                          :labelDate="session && session.startup_application && session.startup_application.label_created_at"
                  ></q-form>
                </div>


              </div>
            </div>
          </div>
        </div>

        <div
          class="flex items-center justify-end w-auto bg-white mt-4 sm:mt-8 sm:p-8 pb-2 -mx-3"
        >
          <sp-button
            theme="outline-blue"
            space="small"
            :disabled="(session.startup_application && session.startup_application.status!='9' && !this.isStartupEcosystem) || inProgress ||buttonDisabled"
            class
            type="submit"
          >{{ $t("form.send")}}</sp-button>
        </div>
      </form>
    </div>
  </div>
</template>
<style>
.border-rr:after {
  content: "";
  position: absolute;
  top: 0;
  right: -12px;
  width: 2px;
  height: 100%;

  background-image: linear-gradient(
    to bottom,
    rgba(210, 216, 224, 0),
    rgba(210, 216, 224, 0.28),
    rgba(210, 216, 224, 0.78),
    rgba(210, 216, 224, 0)
  );
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
@media screen and (max-width: 992px) {
  .border-rr:after {
    display: none;
  }
}
</style>

<script>
import { mapGetters, mapState } from "vuex";
import {
  REQUEST_FORM_GET,
  REQUEST_FORM_SAVE_DRAFT,
  CLEAR_DRAFT_FORM,
  REQUEST_LABEL_GET,
  REQUEST_TEAM_GET
} from "@/store/actions.type";
import QForm from "@/components/Candidat/QForm.vue";
import ButtonVue from "@/components/spKit/Button.vue";
import SelectVue from "@/components/spKit/Select.vue";
import RadioVue from "@/components/spKit/Radio.vue";
import {
  SET_ApplicationMenuActive,
  SET_LabelMenuActive,
  SET_HashId,
  SET_LabelApp
} from "@/store/mutations.type";
export default {
  name: "fromrequest",
  beforeRouteLeave(to, from, next) {
    Promise.all([this.$store.dispatch(CLEAR_DRAFT_FORM)]).then(() => {
      next();
    });
    //next();
  },
  components: {
    "q-form": QForm,
    "sp-button": ButtonVue,
    "sp-select": SelectVue,
    "sp-radio": RadioVue
  },
  data() {
    return {
      inProgress: false,
      responses: [],
      responses_questions: [],
      questions: null,
      isSubmitted: false,
      showError: true,
      team: null,
      teams: [],
      delegation:null,
      showTeam:null,
      buttonDisabled: false,
    };
  },

  props: {
    selectedTeam: {
      required: false,
      type: String,
      default: null
    }
  },
  methods: {
    governoratechange(data){
        this.delegation=data;
    },
    changeTeam(item) {
        this.team = item.user_id;
        this.showTeam = true;
        this.$Progress.start();
        this.$store
            .dispatch(REQUEST_TEAM_GET,  {
                label: this.$route.params.ref,
                type_id: this.$route.params.type_id,
                team : item.value
            })
            .then(data => {
                this.responses_questions = data.data.form.questions;
                this.responses[1].content = data.data.form.questions[1]['response']['content'];
            })
            .catch(response => {
                this.$Progress.finish();
            });
    },
    updateDisabled(val) {
      this.inProgress = val;
      this.isSubmitted = val;
    },
    requestFormSaveDraft() {
      this.$Progress.start();
      let form = this.getForm();
      this.isSubmitted = false;
      this.buttonDisabled = true;
      this.$store
        .dispatch(REQUEST_FORM_SAVE_DRAFT, form)
        .then(() => {
          this.responses = [];
          this.isSubmitted = true;
          this.inProgress = false;
          this.showError = true;
          this.buttonDisabled = false;
          if (form.hasOwnProperty('label') && form.label) {
              if(form.type_id == '7' || form.type_id == '8' || form.type_id == '9' || form.type_id == '10' || form.type_id == '17' || form.type_id == '18' || form.type_id == '19'){
                  this.$router.push({
                      name: "Declarations",
                      params: {
                          app_id: form.id
                      }
                  });
              }else {
                  this.$router.push({
                      name: "Avantages",
                      params: {
                          app_id: form.id
                      }
                  });
              }
          } else if ([17,18,19].includes(form.type_id)) {
            this.$router.push({
              name: "Declarations",
              params: {
                app_id: form.id
              }
            });
          } else {
            this.$router.push({
              name: "Label",
              params: {
                  app_id: form.id
              }
            });
          }
        })
        .catch(() => {
          this.inProgress = false;
          this.buttonDisabled = false;
        });
      window.scrollTo(0, 0);

      this.$Progress.finish();
    },
    getForm() {
      let app_id = this.isStartupEcosystem || localStorage.getItem('ecosystem') === 'true'
        ? this.isStartupEcosystem ? this.ecosystemApp.application.id : this.ecosystemApp.application.hash_id
        : this.session.startup_application.id;
      this.inProgress = true;
      let finalResponses = [];
      Array.prototype.forEach.call(this.responses, final => {
        if (final.content != "") {
          finalResponses.push(final);
        }
      });

      let form;
        if(this.$route.params.type_id == 4 || this.$route.params.type_id == 3){
           form = {
              label: this.$route.params.ref,
              type_id: this.$route.params.type_id,
              member_id: this.team,
              id: app_id,
              responses: finalResponses
          };
      }else if([17,18,19].includes(this.$route.params.type_id)){
        form = {
        type_id: this.$route.params.type_id,
        id: app_id,
        responses: finalResponses
      };
      }else{
           form = {
              label: this.$route.params.ref,
              type_id: this.$route.params.type_id,
              id: app_id,
              responses: finalResponses
          };
      }

      return form;
    }
  },
  mounted() {
    this.$store.commit(SET_LabelMenuActive, 1);
    this.$store.commit(SET_ApplicationMenuActive, 0);
    //this.$store.commit(SET_HashId, this.hashId);
    this.$store.commit(SET_LabelApp, this.$route.params.ref);

    if (this.$route.params.ref) {
      this.$Progress.start();
      if(this.$route.params.type_id == 3 || this.$route.params.type_id == 4){
      //get infos of connected user
      this.$store
      .dispatch(REQUEST_TEAM_GET,  {
          label: this.$route.params.ref,
          type_id: this.$route.params.type_id,
          team : this.session.user_auth.member_id
      })
      .then(data => {
          this.responses_questions = data.data.form.questions;
          this.responses[1].content = data.data.form.questions[1]['response']['content'];
      })
      .catch(response => {
          this.$Progress.finish();
      });
      }

      this.$store
        .dispatch(REQUEST_FORM_GET, {
          label: this.$route.params.ref,
          type_id: this.$route.params.type_id
        })
        .then(data => {
         if(data.data.request_stopped){
            this.$router.push({
                name: "Avantages",
                params: {
                    app_id: data.data.application.id
                }
            });
         }
        if (
          this.session &&
          this.session.startup_application &&
          this.session.startup_application.status != "9" &&
          !this.isStartupEcosystem
        ) {
          this.$router.push({name: "home"})
        }
        this.teams = [];
        let i = 0;
        Array.prototype.forEach.call(Object.values(data.data.teams), key => {
          let option_value = key.name + " " + key.last_name;
          this.teams.push({
            name: option_value,
            firstname: key.name,
            lastname: key.last_name,
            cin: key.cin_number,
            cin_file_path: key.cin_file_path,
            value: key.id,
            user_id:key.user_id
          });
          i++;
        });
        this.$Progress.finish();
        });
    } else {
      this.$Progress.start();
      this.$store
        .dispatch(REQUEST_LABEL_GET, { type_id: this.$route.params.type_id })
        .then(() => {
          this.$Progress.finish();
        });
    }
  },
  watch: {
    errors() {
      this.$Progress.fail();
    }



  },

  computed: {
    ...mapGetters(["session", 
      "ApplicationMenuActive",
      "LabelMenuActive",
      "hashId",
      "LabelApplication", 
      "requestForm",
      "startLeaveDate",
      "startBourseDate",
      "endBourseDate",
      "ecosystemApp"]),
    ...mapState({
      errors: state => state.session.errors
    }),
    isStartupEcosystem() {
      let startupEco = false;
      let hashId = this.$route.params.ref;
      if (hashId) {
        if (
          this.ecosystemApp &&
          this.ecosystemApp.application &&
          ["Air", "Air2", "D4D"].includes(this.ecosystemApp.application.type) &&
          this.ecosystemApp.application.id == hashId
        ) {
          startupEco = true;
        }
      }

      return startupEco;
    },
    newDeclarationReportingTitle() {
      return this.isStartupEcosystem || localStorage.getItem('ecosystem') === 'true' ?
        "Déclaration/Reporting": "Demande";
    }
  }
};
</script>

<style scoped>
.p-4 {
  width: 50%;
  height: 50%;
  font-bold: 500;
}
</style>
